const FormatVat = (value) => {
    const vat = value / 100;
    return `${parseFloat(vat.toFixed(2))}%`;
};

export default FormatVat;
